import { indexedDbStorage } from "../adapters/storage.js";

/**
 * « Effacer les données de cet appareil » (Paramètres › Mon compte).
 *
 * Tout ce que Hoa garde sur ce téléphone disparaît : la clé du compte et les
 * reçus (IndexedDB « gomgom »), les soirées, les points sans compte, le
 * pseudo, la photo, le thème, les réglages de notification (localStorage),
 * la tribu en cours (sessionStorage). Le compte, lui, reste sur le serveur :
 * on s'y reconnecte avec son e-mail et son mot de passe.
 */
export async function effacerAppareil(): Promise<void> {
  // Vider d'abord le contenu : même si la suppression de la base attend, la clé est partie.
  try {
    await indexedDbStorage.clear();
  } catch {
    /* pas de base */
  }
  try {
    localStorage.clear();
  } catch {
    /* navigation privée */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* idem */
  }
  await new Promise<void>((fini) => {
    try {
      const r = indexedDB.deleteDatabase("gomgom");
      r.onsuccess = r.onerror = () => fini();
      // Une autre vue encore ouverte bloque l'effacement : il se fera à sa fermeture.
      r.onblocked = () => fini();
    } catch {
      fini();
    }
  });
  try {
    if ("caches" in window) for (const k of await caches.keys()) await caches.delete(k);
  } catch {
    /* pas de cache */
  }
  try {
    const regs = (await navigator.serviceWorker?.getRegistrations()) ?? [];
    for (const r of regs) await r.unregister();
  } catch {
    /* pas de service worker */
  }
}
